import federation from '/builds/DzbhxRQc/0/lightspeed-b2b/web/frontend/node_modules/@module-federation/webpack-bundler-runtime/dist/index.cjs.js';

var prevFederation = __webpack_require__.federation;
__webpack_require__.federation = {}
for(var key in federation){
	__webpack_require__.federation[key] = federation[key];
}
for(var key in prevFederation){
	__webpack_require__.federation[key] = prevFederation[key];
}
if(!__webpack_require__.federation.instance){

	__webpack_require__.federation.instance = __webpack_require__.federation.runtime.init(__webpack_require__.federation.initOptions);
	if(__webpack_require__.federation.attachShareScopeMap){
		__webpack_require__.federation.attachShareScopeMap(__webpack_require__)
	}
	if(__webpack_require__.federation.installInitialConsumes){
		__webpack_require__.federation.installInitialConsumes()
	}
}